import './TeamScoreEditRowMobile.scss';

import { Edit } from '@mui/icons-material';
import { Button } from '@mui/material';
import classNames from 'classnames';
import { MatchParticipant } from 'domain/event/match/MatchParticipant';
import { SystemPointsEnum } from 'domain/event/SystemPoints.enum';
import { TypeEventCodeEnum } from 'domain/event/TypeEventCodeEnum';
import { formatDate } from 'helper/date.helper';
import { Match } from 'primary/Components/bracket/CustomBracket/types';
import { ModalEditScoreParticipantBR } from 'primary/events/components/matchs/edit/ModalEditScoreParticipantBR';
import { useBooleanToggle } from 'primary/hooks/useBooleanToggle';
import { useTranslate } from 'primary/hooks/useTranslate';
import React from 'react';

type TeamScoreEditRowMobileProps = {
  match: Match;
  participant: MatchParticipant;
  className?: string;
  systemPoint?: SystemPointsEnum;
  onEdited: () => void;
  typeEvent: TypeEventCodeEnum;
  isClassementReadOnly?: boolean;
  asView?: boolean;
  withoutDate?: boolean;
};

export const ParticipantEditRowMobile = ({
  systemPoint = SystemPointsEnum.DEFAULT,
  className,
  participant,
  onEdited,
  typeEvent,
  match,
  isClassementReadOnly,
  asView,
  withoutDate,
}: TeamScoreEditRowMobileProps) => {
  const t = useTranslate();
  const [isOpenEditScore, , openEditScore, closeEditScore] = useBooleanToggle();
  const handleValidateEditScore = () => {
    onEdited();
    closeEditScore();
  };

  const position =
    participant.score === null
      ? undefined
      : match.participants
          .sort((a, b) => b.score - a.score)
          .findIndex((p) => p.id === participant.id) + 1;
  const isParticipantTop = position ? position === 1 : false;
  const isParticipantTop3 = !isParticipantTop && position ? position <= 3 : false;
  const isParticipantTopHalf =
    !isParticipantTop && !isParticipantTop3 && position
      ? position <= match.participants.length / 2
      : false;

  return (
    <div className={classNames('teamScoreEditRowMobile', className)}>
      <div className={classNames('teamScoreEditRowMobile__teams', '-casePart')}>
        <div className={'-teamsContainer'}>
          <div className={'-team'}>
            {!withoutDate && (
              <span className={'-date'}>
                {match.startDate
                  ? formatDate(match.startDate, 'readable(with hour)')
                  : '--/--/----'}
              </span>
            )}
            <div className={'-nameContainer -left'}>
              <span
                className={classNames('-teamName', {
                  '-withoutIcon':
                    (!isParticipantTop && !isParticipantTop3 && !isParticipantTopHalf) ||
                    position === undefined,
                })}
              >
                {participant?.eventParticipant.team?.name ??
                  t('event.matchs.edit.editScore.noTeam')}
              </span>
            </div>
            <div className={'-teamsContainer__scoreWithIcon -left'}>
              {participant.eventParticipant.event.pointSystem ===
                SystemPointsEnum.DEFAULT && (
                <span className={'-teamPosition'}>
                  {!position ? 'N/A' : `Position: ${position}`}
                </span>
              )}
              {participant.eventParticipant.event.pointSystem ===
                SystemPointsEnum.PERSO && (
                <span className={'-teamScore'}>
                  {participant.score === undefined
                    ? 'N/A'
                    : `Score: ${participant.score}`}
                </span>
              )}
            </div>
          </div>
        </div>
        {!asView && (
          <div className={'-actionContainer'}>
            <Button
              color={'primary'}
              style={{ justifySelf: 'flex-end' }}
              variant={'text'}
              onClick={openEditScore}
              disabled={isClassementReadOnly}
            >
              <Edit />
            </Button>
          </div>
        )}
      </div>
      {!asView && (
        <ModalEditScoreParticipantBR
          retry={onEdited}
          systemPoint={systemPoint}
          isOpen={isOpenEditScore}
          handleClose={closeEditScore}
          onValidEdit={handleValidateEditScore}
          match={match.unpyMatch}
          participant={participant}
        />
      )}
    </div>
  );
};
